import React from 'react'

class managerButtonSaveHint extends React.Component{
    render(){            
        return (<span className="color-button-des" style={{fontSize :'18px'}}>需按[儲存設定]才能送出客服審核<br /></span>);
      }
}

export default managerButtonSaveHint;